import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import styled from "styled-components";
import Layout from "./components/layout/Layout";
import NotFoundRedirect from "./components/language/NotFoundRedirect";
import LanguageRedirect from "./components/language/LanguageRedirect";
import LandingPage from "./pages/LandingPage";

// 페이지 컴포넌트 지연 로딩
const HomePage = lazy(() => import("./pages/HomePage"));
const HomePageVer2 = lazy(() => import("./pages/HomePageVer2"));
const TechCompanyHomePage = lazy(() => import("./pages/TechCompanyHomePage"));
const TechPracticePage = lazy(() => import("./pages/TechPracticePage"));
const PracticeAreasPage = lazy(() => import("./pages/PracticeAreasPage"));
const PracticeAreaDetailPage = lazy(
  () => import("./pages/PracticeAreaDetailPage"),
);

const InternationalPage = lazy(() => import("./pages/InternationalPage"));
const MonetizationPage = lazy(() => import("./pages/MonetizationPage"));

const CasesPage = lazy(() => import("./pages/CasePage"));
const CasesPage_2 = lazy(() => import("./pages/CasePageVer2"));

const CaseDetailPage = lazy(() => import("./pages/CaseDetailPage"));
const CaseDetailPage_2 = lazy(() => import("./pages/CaseDetailPageVer2"));

const MembersPage = lazy(() => import("./pages/MembersPage"));
const MembersPage_2 = lazy(() => import("./pages/MembersPageVer2"));
const MemberDetailPage = lazy(() => import("./pages/MemberDetailPage"));

const MemberDetailPage_2 = lazy(() => import("./pages/MemberDetailPageVer2"));

const NewsPage_2 = lazy(() => import("./pages/NewsPage_ver_2"));
const NewsPage = lazy(() => import("./pages/NewsPage"));
const NewsDetailPage = lazy(() => import("./pages/NewsDetailPage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));

const PracticeAreasPage_2 = lazy(() => import("./pages/PracticeAreasPageVer2"));

const ContactPage = lazy(() => import("./pages/ContactPage"));
const ApplyPage = lazy(() => import("./pages/ApplyPage"));

/////////////////////////////////

const SamplePage = lazy(() => import("./pages/SamplePage"));
const SamplePage_2 = lazy(() => import("./pages/SamplePage_2"));

const SamplePage_coupang = lazy(() => import("./pages/SamplePage_coupang"));

const SamplePage_generalOffice = lazy(
  () => import("./pages/SamplePage_generalOffice"),
);
const SamplePage_kb = lazy(() => import("./pages/SamplePage_kb"));

const SamplePage_sample = lazy(() => import("./pages/SamplePage_sample"));

const SamplePage_bank = lazy(() => import("./pages/SamplePage_bank"));

const SamplePage_flour = lazy(() => import("./pages/SamplePage_flour"));

const SamplePage_sugar = lazy(
  () => import("./pages/eventPage/SamplePage_sugar"),
);

const SamplePage_paper = lazy(
  () => import("./pages/eventPage/SamplePage_paper"),
);
const SamplePage_fukushima = lazy(
  () => import("./pages/eventPage/SamplePage_fukushima"),
);
const SamplePage_car = lazy(() => import("./pages/eventPage/SamplePage_car"));

const SamplePage_tariff = lazy(
  () => import("./pages/eventPage/SamplePage_tariff"),
);
const ClassActionTemplateExample = lazy(
  () => import("./pages/eventPage/ClassActionTemplateExample"),
);

/////////////////////////////////

const NoticePage = lazy(() => import("./pages/NoticePage"));
const NoticePage_2 = lazy(() => import("./pages/NoticePage_ver_2"));
const NoticeDetailPage = lazy(() => import("./pages/NoticeDetailPage"));

const NoticeDetailPage_2 = lazy(() => import("./pages/NoticeDetailPage_ver_2"));
const PublicationsPage = lazy(() => import("./pages/PublicationsPage"));
const PublicationDetailPage = lazy(() => import("./pages/PublicationDetailPage"));
const NewslettersPage = lazy(() => import("./pages/NewslettersPage"));
const NewsletterDetailPage = lazy(() => import("./pages/NewsletterDetailPage"));

const PartnerPage = lazy(() => import("./pages/PartnerPage"));
const RecruitPage = lazy(() => import("./pages/RecruitPage"));

const ContractPage = lazy(() => import("./pages/ContractPage"));

// 로딩 컴포넌트
const LoadingFallback = () => (
  <div className="loading-container">
    <div className="loading-spinner"></div>
    <p>로딩 중...</p>
  </div>
);

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
`;

function App() {
  return (
    <Router>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<LanguageRedirect />} />

          <Route path="/:lang" element={<Layout />}>
            <Route index element={<TechCompanyHomePage />} />
            <Route path="tech-home" element={<TechCompanyHomePage />} />
            <Route path="tech-practice" element={<TechPracticePage />} />
            <Route path="practice-areas" element={<TechPracticePage />} />
            <Route
              path="practice-areas/:id"
              element={<PracticeAreaDetailPage />}
            />
            <Route path="partner" element={<PartnerPage />} />
            <Route path="recruit" element={<RecruitPage />} />

            <Route path="members" element={<MembersPage_2 />} />
            {/*  <Route path="test" element={<MembersPage_2 />} /> */}

            {/* <Route path="test/:id" element={<MemberDetailPage_2 />} /> */}
            <Route path="members/:id" element={<MemberDetailPage_2 />} />
            <Route path="news" element={<NewsPage_2 />} />
            <Route path="csv" element={<InternationalPage />} />
            <Route path="monetization" element={<MonetizationPage />} />

            {/*<Route path="news/:id" element={<NewsDetailPage />} />*/}
            <Route path="about" element={<AboutPage />} />

            <Route path="contact" element={<ContactPage />} />
            <Route path="cases" element={<CasesPage_2 />} />
            <Route path="cases/:id" element={<CaseDetailPage_2 />} />

            <Route path="contract" element={<ContractPage />} />
            {/*<Route path="test" element={<CasesPage_2 />} />*/}
            {/*<Route path="test/:id" element={<CaseDetailPage_2 />} />*/}

            <Route path="app" element={<SamplePage />} />

            <Route path="sample" element={<SamplePage_sample />} />
            <Route path="class-action" element={<SamplePage_2 />} />
            <Route path="coupang" element={<SamplePage_coupang />} />
            <Route path="bank" element={<SamplePage_bank />} />
            <Route path="flour" element={<SamplePage_flour />} />
            <Route path="sugar" element={<SamplePage_sugar />} />
            <Route path="fukushima" element={<SamplePage_fukushima />} />
            <Route path="car" element={<SamplePage_car />} />
            <Route path="paper" element={<SamplePage_paper />} />
            <Route path="tariff" element={<SamplePage_tariff />} />
            <Route
              path="general-office"
              element={<SamplePage_generalOffice />}
            />
            <Route path="kb" element={<SamplePage_kb />} />
            <Route path="app_apply" element={<ApplyPage />} />
            <Route path="notice" element={<NoticePage_2 />} />
            <Route path="notice/:id" element={<NoticeDetailPage_2 />} />
            <Route path="publications" element={<PublicationsPage />} />
            <Route
              path="publications/:id"
              element={<PublicationDetailPage />}
            />
            <Route path="newsletters" element={<NewslettersPage />} />
            <Route
              path="newsletters/:id"
              element={<NewsletterDetailPage />}
            />
          </Route>

          <Route path="/:lang/*" element={<NotFoundRedirect />} />
          <Route path="/*" element={<NotFoundRedirect />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
